import { Suspense, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Loading from "../Common/Loading";
import { Sidebar } from "./Sidebar";

export function Layout() {
  const location = useLocation();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Reset scroll position to top when route changes
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen w-full flex overflow-hidden bg-slate-950 text-white md:h-screen">
      <Sidebar />
      <main className="flex-1 flex flex-col relative min-w-0 w-full">
        <div ref={scrollContainerRef} className="flex-1 overflow-auto relative">
          <Suspense fallback={<Loading />}>
            <Outlet />
          </Suspense>
        </div>
      </main>
    </div>
  );
}
